import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Signup from './components/Signup/Signup';
import Login from './components/Login/Login';

import 'bootstrap/dist/css/bootstrap.min.css';
import FileTable from './components/FileTable/FileTable';
import Dashboardd from './components/Dashboard/Dashboard';
import LandingPage from './components/LandingPage/LandingPage';



function App() {
    return (
        <Router>
            <Routes>
                 <Route path="/" element={<LandingPage />} />
                <Route path="/sign" element={<Signup />} />
                <Route path="/login" element={<Login />} />
                <Route path="/dashboard" element={<Dashboardd />} />
                <Route path='/qrs' element={<FileTable/>}/>
            </Routes>
        </Router>
    );
}

export default App;
